<app-loading-spinner
    [active]="loadingContent || loadingSignatureGroup"></app-loading-spinner>

<form [formGroup]="form">
    <div class="row">
        <div class="col-12">
            <app-radio [multiple]="true" [(ngModel)]="haveAgent"
                (onCheckChanged)="handleHaveAgent($event)"
                [ngModelOptions]="{standalone: true}">Sou
                representado por um terceiro
            </app-radio>
            <app-spacer [bottom]="24"></app-spacer>
        </div>
    </div>


    <ng-container *ngIf="haveAgent">
        <ng-container *ngIf="!showForm ">
            <div class="row">
                <div class="col-12">
                    <table class="custom-table">
                        <thead>
                            <tr>
                                <th class="expand-column"></th>
                                <th>Nome/Razão social</th>
                                <th>CPF/CNPJ</th>
                                <th>Tipo</th>
                                <th class="actions-column">Ações</th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container
                                *ngFor="let item of data; let i = index">
                                <!-- Main row -->
                                <tr>
                                    <td class="expand-column">
                                        <button
                                            *ngIf="isCompanyRepresentative(item)"
                                            (click)="toggleRowExpansion(i)"
                                            class="expand-button" type="button">
                                            <svg-icon
                                                src="assets/images/icon-right.svg"
                                                *ngIf="!isRowExpanded(i)"></svg-icon>
                                            <svg-icon
                                                src="assets/images/icon-down.svg"
                                                *ngIf="isRowExpanded(i)"></svg-icon>
                                        </button>
                                    </td>
                                    <td>{{ getRepresentativeName(item) }}</td>
                                    <td>{{ getRepresentativeDocument(item) }}
                                    </td>
                                    <td>{{ getRepresentativeType(item) }}</td>
                                    <td class="actions-column">
                                        <div class="d-flex justify-content-end">
                                            <ng-container
                                                *ngIf="canEditRepresentative(item)">
                                                <app-tooltip text="Editar"
                                                    position="top">
                                                    <button
                                                        class="app-table-remove mr-2"
                                                        (click)="handleEditData(i)">
                                                        <svg-icon
                                                            src="assets/images/icon-edit.svg"
                                                            fill="var(--white)"></svg-icon>
                                                    </button>
                                                </app-tooltip>
                                            </ng-container>
                                            <ng-container
                                                *ngIf="!canEditRepresentative(item)">
                                                <span
                                                    style="width: 32px; display: inline-block;"></span>
                                            </ng-container>
                                            <app-tooltip text="Excluir"
                                                position="top">
                                                <button
                                                    class="app-table-remove trash-icon"
                                                    (click)="handleRemoveData(i)">
                                                    <svg-icon
                                                        src="assets/images/icon-trash.svg"></svg-icon>
                                                </button>
                                            </app-tooltip>
                                        </div>
                                    </td>
                                </tr>

                                <!-- Expanded row for company representatives -->
                                <tr *ngIf="isCompanyRepresentative(item) && isRowExpanded(i)"
                                    class="expanded-row-content">
                                    <td colspan="5">
                                        <div class="sub-table-container">
                                            <h4>Representantes vinculados</h4>

                                            <div *ngIf="isLoadingCompanyReps(i)"
                                                class="p-3">
                                                <ngx-skeleton-loader
                                                    [theme]="{ height: '40px', width: '100%', marginBottom: '8px' }"
                                                    count="2"></ngx-skeleton-loader>
                                            </div>

                                            <div
                                                *ngIf="!isLoadingCompanyReps(i)">
                                                <table
                                                    *ngIf="getCompanyRepresentatives(i).length > 0"
                                                    class="sub-table">
                                                    <thead>
                                                        <tr>
                                                            <th>Nome</th>
                                                            <th>Documento</th>
                                                            <th>Assina</th>
                                                            <th>Obrigatório</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr
                                                            *ngFor="let rep of getCompanyRepresentatives(i)">
                                                            <td>{{ rep.name }}
                                                            </td>
                                                            <td>{{
                                                                formatCpfCnpj(rep.document)
                                                                }}</td>
                                                            <td>{{ rep.canSign ?
                                                                'Sim' : 'Não' }}
                                                            </td>
                                                            <td>{{
                                                                rep.isMandatory
                                                                ? 'Sim' : 'Não'
                                                                }}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <div *ngIf="getCompanyRepresentatives(i).length === 0"
                                                    class="text-center p-3 text-muted">
                                                    Nenhum representante
                                                    vinculado encontrado.
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </ng-container>
                        </tbody>
                    </table>
                    <app-spacer [bottom]="32"></app-spacer>
                </div>
            </div>
        </ng-container>


        <ng-container *ngIf="showForm">
            <div class="row">
                <div class="col-12">
                    <div class="d-flex align-items-center mb-2">
                        <label class="pep-title mr-1" style="margin: 0;">
                            Tipo de representante
                        </label>
                    </div>
                    <div class="d-flex">
                        <app-radio [multiple]="false"
                            [isChecked]="form.controls.representative_type.value === 'person'"
                            (onCheckChanged)="handleRepresentativeTypeChange($event, 'person')"
                            [value]="'person'">
                            <div class="flex-1 d-flex flex-column">
                                <span class="pep-title">Pessoa
                                    Representante</span>
                            </div>
                        </app-radio>
                        <app-spacer [right]="24"></app-spacer>
                        <app-radio [multiple]="false"
                            [isChecked]="form.controls.representative_type.value === 'company'"
                            (onCheckChanged)="handleRepresentativeTypeChange($event, 'company')"
                            [value]="'company'">
                            <div class="flex-1 d-flex flex-column">
                                <span class="pep-title">Empresa
                                    Representante</span>
                            </div>
                        </app-radio>
                    </div>
                    <app-spacer [bottom]="24"></app-spacer>
                </div>
            </div>

            <ng-container
                *ngIf="form.controls.representative_type.value === 'company'">
                <div class="row">
                    <div class="col-12 col-lg-6">
                        <app-masked-input [group]="form" controlName="cnpj"
                            label="CNPJ" placeholder="00.000.000/0000-00"
                            documentType="cnpj"
                            (onChange)="searchCompanyByCnpj($event)">
                        </app-masked-input>
                        <app-spacer [bottom]="24"></app-spacer>
                    </div>
                </div>

                <div class="row"
                    *ngIf="companyLookupName || loadingCompanyRepresentatives">
                    <div class="col-12">
                        <label class="pep-title">Empresa encontrada</label>
                        <div style="font-weight: 600; font-size: 18px;">
                            <ngx-skeleton-loader
                                *ngIf="loadingCompanyRepresentatives" [theme]="{
                                    height: '20px',
                                    width: '320px',
                                    marginBottom: '0'
                                }">
                            </ngx-skeleton-loader>

                            <ng-container
                                *ngIf="!loadingCompanyRepresentatives">
                                {{ companyLookupName | uppercase }}
                            </ng-container>
                        </div>
                        <app-spacer [bottom]="16"></app-spacer>

                        <ng-container *ngIf="!loadingCompanyRepresentatives">
                            <label class="pep-title">Representantes
                                vinculados</label>
                            <div *ngIf="companyRepresentatives.length === 0"
                                class="pep-title">
                                Nenhum representante vinculado
                            </div>
                            <app-table *ngIf="companyRepresentatives.length > 0"
                                [columns]="companyRepresentativesColumns"
                                [data]="companyRepresentatives"
                                [removeButton]="true">
                            </app-table>

                            <!-- Alerta de empresa não homologada (Principal) - MOVIMENTADO PARA BAIXO -->
                            <div *ngIf="companyLookupStatus && companyLookupStatus !== 'homologado'"
                                class="mt-3 p-3 rounded d-flex align-items-center representative-error-alert">
                                <svg-icon
                                    src="assets/images/icon-warning.svg"></svg-icon>
                                <span>
                                    Esta empresa possui o status <strong>{{
                                        companyLookupStatus | uppercase
                                        }}</strong>.
                                    Somente empresas homologadas podem ser
                                    vinculadas como representantes.
                                </span>
                            </div>
                        </ng-container>
                        <app-spacer [bottom]="24"></app-spacer>
                    </div>
                </div>

                <!-- Mandato só aparece se homologado -->
                <div class="row"
                    *ngIf="companyLookupName && !loadingCompanyRepresentatives && companyLookupStatus === 'homologado'">
                    <div class="col-12 col-lg-4">
                        <app-masked-input [group]="form"
                            controlName="term_validity" mask="00/00/0000"
                            label="Início do mandato" placeholder="dd/mm/aaaa">
                        </app-masked-input>
                        <app-spacer [bottom]="24"></app-spacer>
                    </div>

                    <div class="col-12 col-lg-4">
                        <app-masked-input [group]="form"
                            [readOnly]="isIndefinite"
                            controlName="max_term_validity" mask="00/00/0000"
                            label="Validade do mandato"
                            placeholder="dd/mm/aaaa">
                        </app-masked-input>
                        <app-spacer [bottom]="24"></app-spacer>
                    </div>

                    <div class="col-12 col-lg-4">
                        <app-spacer [bottom]="36"></app-spacer>
                        <app-radio [multiple]="true"
                            formControlName="indefinite_term">
                            Validade indeterminada
                        </app-radio>
                    </div>
                </div>
            </ng-container>


            <div class="row"
                *ngIf="form.controls.representative_type.value === 'person'">
                <div class="col-12 col-lg-4 cep-container">
                    <app-masked-input [group]="form" controlName="document"
                        label="CPF" placeholder="000.000.000-00"
                        mask="000.000.000-00"
                        (onChange)="searchRepresentative($event)">
                    </app-masked-input>
                    <svg-icon src="assets/images/icon-loading.svg"
                        *ngIf="loadingRepresentative"
                        class="app-button-icon"></svg-icon>
                </div>
            </div>

            <app-spacer [bottom]="24"></app-spacer>


            <ng-container
                *ngIf="form.controls.representative_type.value === 'person' && representativeFetched">
                <div class="row">
                    <div class="col-12 col-lg-8">
                        <app-input [group]="form" controlName="full_name"
                            label="Nome Completo" [maxLength]="60">
                        </app-input>
                        <app-spacer [bottom]="24"></app-spacer>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 col-lg-4">
                        <app-masked-input [group]="form"
                            controlName="birth_date" mask="00/00/0000"
                            label="Data de nascimento" placeholder="dd/mm/aaaa">
                        </app-masked-input>
                        <app-spacer [bottom]="24"></app-spacer>
                    </div>

                    <div class="col-12 col-lg-4">
                        <app-select
                            [items]="signupService.choices().marital_choices"
                            [group]="form" controlName="marital_status"
                            label="Estado civil" placeholder="Selecione">
                        </app-select>
                        <app-spacer [bottom]="24"></app-spacer>
                    </div>
                </div>

                <ng-container
                    *ngIf="form.controls.marital_status.value === '2' || this.form.controls['marital_status'].value === '3'">
                    <div class="row">
                        <div class="col-12 col-lg-4">
                            <app-masked-input [group]="form"
                                controlName="spouse_document"
                                label="CPF do cônjuge"
                                placeholder="000.000.000-00"
                                mask="000.000.000-00">
                            </app-masked-input>
                            <app-spacer [bottom]="24"></app-spacer>
                        </div>

                        <div class="col-12 col-lg-4">
                            <app-masked-input [group]="form"
                                controlName="spouse_name"
                                label="Nome do cônjuge" mask="W*"
                                [readOnly]="foundSpouse" [usePatterns]="true">
                            </app-masked-input>
                            <app-spacer [bottom]="24"></app-spacer>
                        </div>

                        <div class="col-12 col-lg-4">
                            <app-select
                                [items]="signupService.choices().marital_statutes"
                                [group]="form" controlName="spouse_statute"
                                label="Regime de casamento">
                            </app-select>
                            <app-spacer [bottom]="24"></app-spacer>
                        </div>
                    </div>
                </ng-container>

                <div class="row">
                    <div class="col-12 col-lg-12">
                        <app-input [group]="form" controlName="occupation"
                            [maxLength]="30" label="Ocupação Profissional">
                        </app-input>
                        <app-spacer [bottom]="24"></app-spacer>
                    </div>

                    <div class="col-12 col-lg-3">
                        <app-select [items]="signupService.nationalityChocies"
                            [group]="form" controlName="nationality"
                            placeholder="Selecione" label="País de origem">
                        </app-select>
                        <app-spacer [bottom]="24"></app-spacer>
                    </div>

                    <div class="col-12 col-lg-2">
                        <app-select [items]="signupService.ufs_ids"
                            [group]="form" controlName="naturalness"
                            [readOnly]="isForeign" label="Naturalidade">
                        </app-select>
                        <app-spacer [bottom]="24"></app-spacer>
                    </div>

                    <div class="col-12 col-lg-6">
                        <app-select [items]="cities_options" [group]="form"
                            controlName="naturalness_city" label="Cidade"
                            [readOnly]="!form.controls.naturalness.value"
                            [placeholder]="form.controls.naturalness.value ? 'Selecione a cidade' : 'Selecione um Estado primeiro'">
                        </app-select>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 col-lg-6">
                        <app-select
                            [items]="signupService.choices().document_types"
                            [group]="form" controlName="document_type"
                            label="Tipo de documento" placeholder="Selecione">
                        </app-select>
                        <app-spacer [bottom]="24"></app-spacer>
                    </div>

                    <div class="col-12 col-lg-6">
                        <app-input [group]="form" controlName="rg"
                            [maxLength]="20" label="Número do Documento"
                            placeholder="0000000">
                        </app-input>
                        <app-spacer [bottom]="24"></app-spacer>
                    </div>

                    <div class="col-12 col-lg-6">
                        <app-select [items]="signupService.issuingAgencies"
                            [group]="form" controlName="issuing_agency"
                            label="Órgão expedidor">
                        </app-select>
                        <app-spacer [bottom]="24"></app-spacer>
                    </div>

                    <div class="col-12 col-lg-2">
                        <app-select [items]="signupService.ufs" [group]="form"
                            controlName="issuing_uf" label="UF">
                        </app-select>
                        <app-spacer [bottom]="24"></app-spacer>
                    </div>

                    <div class="col-12 col-lg-4">
                        <app-masked-input [group]="form"
                            controlName="shipping_date" mask="00/00/0000"
                            label="Data expedição" placeholder="dd/mm/aaaa">
                        </app-masked-input>
                        <app-spacer [bottom]="24"></app-spacer>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 col-lg-2">
                        <app-select [group]="form" controlName="celphone_ddi"
                            [items]="DDIOptions" label="DDI">
                        </app-select>
                        <app-spacer [bottom]="24"></app-spacer>
                    </div>

                    <div class="col-12 col-lg-4">
                        <app-masked-input [group]="form"
                            controlName="celphone_number" label="Celular"
                            mask="(00) 00000-0000"
                            placeholder="(00) 0 0000-0000">
                        </app-masked-input>
                        <app-spacer [bottom]="24"></app-spacer>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 col-lg-6">
                        <app-input [group]="form" controlName="email"
                            label="E-mail">
                        </app-input>
                        <app-spacer [bottom]="24"></app-spacer>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 col-lg-4">
                        <app-masked-input [group]="form"
                            controlName="term_validity" mask="00/00/0000"
                            label="Início do mandato" placeholder="dd/mm/aaaa">
                        </app-masked-input>

                        <app-spacer [bottom]="24"></app-spacer>
                    </div>

                    <div class="col-12 col-lg-4">
                        <app-masked-input [group]="form"
                            [readOnly]="isIndefinite"
                            controlName="max_term_validity" mask="00/00/0000"
                            label="Validade do mandato"
                            placeholder="dd/mm/aaaa">
                        </app-masked-input>
                        <app-spacer [bottom]="24"></app-spacer>
                    </div>

                    <div class="col-12 col-lg-4">
                        <app-spacer [bottom]="36"></app-spacer>
                        <app-radio [multiple]="true"
                            formControlName="indefinite_term">
                            Validade indeterminada
                        </app-radio>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <app-radio [multiple]="true" formControlName="pep">
                            <div class="flex-1 d-flex flex-column">
                                <span class="pep-title">Considera-se PEP</span>
                                <app-spacer [bottom]="8"></app-spacer>
                                <span class="pep-description">Considera-se
                                    Pessoa
                                    Exposta Politicamente (PEP), nos termos da
                                    legislação em
                                    vigor, (i) agente público que desempenha ou
                                    tenha desempenhado, nos últimos cinco anos,
                                    no
                                    Brasil ou em
                                    países, territórios e dependências
                                    estrangeiras,
                                    cargos, empregos ou funções públicas
                                    relevantes; ou
                                    (ii) representante, familiar (parente na
                                    linha
                                    reta até primeiro grau, cônjuge,
                                    companheiro(a) ou
                                    enteado(a)).</span>
                            </div>
                        </app-radio>
                        <app-spacer [bottom]="48"></app-spacer>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 col-lg-4 cep-container">
                        <app-masked-input [group]="form" controlName="zipcode"
                            label="CEP" mask="00000-000" placeholder="00000-000"
                            (input)="handleSearchZipcode($event)">
                        </app-masked-input>
                        <svg-icon src="assets/images/icon-loading.svg"
                            *ngIf="searchingZipcode"
                            class="app-button-icon"></svg-icon>
                    </div>
                </div>
                <app-spacer [bottom]="24"></app-spacer>

                <ng-container *ngIf="zipcodeFetched">
                    <div class="row">
                        <div class="col-12 col-lg-6">
                            <app-input [group]="form" controlName="public_place"
                                [readOnly]="addressObj.public_place !== ''"
                                [maxLength]="30" label="Logradouro">
                            </app-input>
                            <app-spacer [bottom]="24"></app-spacer>
                        </div>

                        <div class="col-12 col-lg-2">
                            <app-input [group]="form" controlName="number"
                                type="number" label="Número">
                            </app-input>
                            <app-spacer [bottom]="24"></app-spacer>
                        </div>

                        <div class="col-12 col-lg-4">
                            <app-input [group]="form" controlName="complement"
                                [maxLength]="20" label="Complemento">
                            </app-input>
                            <app-spacer [bottom]="24"></app-spacer>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12 col-lg-6">
                            <app-input [group]="form" controlName="district"
                                [readOnly]="addressObj.district !== ''"
                                [maxLength]="30" label="Bairro">
                            </app-input>
                            <app-spacer [bottom]="24"></app-spacer>
                        </div>

                        <div class="col-12 col-lg-4">
                            <app-input [group]="form" controlName="city"
                                label="Cidade" [maxLength]="30"
                                [readOnly]="addressObj.city !== ''">
                            </app-input>
                            <app-spacer [bottom]="24"></app-spacer>
                        </div>

                        <div class="col-12 col-lg-2">
                            <app-select [items]="signupService.ufs"
                                [group]="form" controlName="uf" label="UF"
                                [readOnly]="addressObj.uf !== ''">
                            </app-select>
                            <app-spacer [bottom]="24"></app-spacer>
                        </div>

                        <div class="col-12 col-lg-4">
                            <app-select
                                [items]="signupService.nationalityChocies"
                                [group]="form" controlName="country"
                                label="País"
                                [readOnly]="addressObj.country !== ''">
                            </app-select>
                            <app-spacer [bottom]="24"></app-spacer>
                        </div>
                    </div>
                </ng-container>
            </ng-container>
        </ng-container>

        <app-side-modal [active]="addAnotherModal" [title]="renderTitle()"
            (onClose)="handleCloseModal()" paddingBottom="0">
            <div class="container">
                <div class="row" *ngIf="selectedRepresentative === null">
                    <div class="col-12">
                        <div class="d-flex align-items-center mb-2">
                            <label class="pep-title mr-1" style="margin: 0;">
                                Tipo de representante
                            </label>
                        </div>
                        <div class="d-flex">
                            <app-radio [multiple]="false"
                                [isChecked]="form.controls.representative_type.value === 'person'"
                                (onCheckChanged)="handleRepresentativeTypeChange($event, 'person')"
                                [value]="'person'"
                                [readOnly]="selectedRepresentative !== null">
                                <div class="flex-1 d-flex flex-column">
                                    <span class="pep-title">Pessoa
                                        Representante</span>
                                </div>
                            </app-radio>
                            <app-spacer [right]="24"></app-spacer>
                            <app-radio [multiple]="false"
                                [isChecked]="form.controls.representative_type.value === 'company'"
                                (onCheckChanged)="handleRepresentativeTypeChange($event, 'company')"
                                [value]="'company'"
                                [readOnly]="selectedRepresentative !== null">
                                <div class="flex-1 d-flex flex-column">
                                    <span class="pep-title">Empresa
                                        Representante</span>
                                </div>
                            </app-radio>
                        </div>
                        <app-spacer [bottom]="24"></app-spacer>
                    </div>
                </div>

                <ng-container
                    *ngIf="form.controls.representative_type.value === 'company'">

                    <!-- CNPJ Input - Always visible when adding company representative -->
                    <div class="row" *ngIf="selectedRepresentative === null">
                        <div class="col-12 col-lg-6">
                            <app-masked-input [group]="form" controlName="cnpj"
                                label="CNPJ" placeholder="00.000.000/0000-00"
                                documentType="cnpj"
                                (onChange)="searchCompanyByCnpj($event)">
                            </app-masked-input>
                            <app-spacer [bottom]="24"></app-spacer>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12"
                            *ngIf="companyLookupName || loadingCompanyRepresentatives">
                            <label class="pep-title"
                                *ngIf="selectedRepresentative === null">Empresa
                                encontrada</label>
                            <div style="font-weight: 600; font-size: 18px;">
                                <ngx-skeleton-loader
                                    *ngIf="loadingCompanyRepresentatives"
                                    [theme]="{
                                        height: '20px',
                                        width: '320px',
                                        marginBottom: '0'
                                    }">
                                </ngx-skeleton-loader>
                                <ng-container
                                    *ngIf="!loadingCompanyRepresentatives">
                                    {{ companyLookupName | uppercase }}
                                </ng-container>
                            </div>
                            <!-- CNPJ Text Display for Edit Mode -->
                            <div *ngIf="selectedRepresentative !== null && !loadingCompanyRepresentatives"
                                style="font-weight: 500; font-size: 16px; margin-top: 4px; margin-bottom: 16px;">
                                CNPJ: {{ form.controls.cnpj.value }}
                            </div>
                            <app-spacer [bottom]="16"></app-spacer>

                            <app-spacer [bottom]="16"></app-spacer>
                            <label class="pep-title">Representantes
                                vinculados</label>
                            <div *ngIf="loadingCompanyRepresentatives"
                                class="skeleton-table">
                                <ngx-skeleton-loader [theme]="{
                            height: '72px',
                            width: '100%',
                            marginBottom: '0'
                        }">
                                </ngx-skeleton-loader>
                            </div>
                            <app-table
                                *ngIf="!loadingCompanyRepresentatives && companyRepresentatives.length > 0"
                                [columns]="companyRepresentativesColumns"
                                [data]="companyRepresentatives"
                                [removeButton]="true">
                            </app-table>
                            <div *ngIf="!loadingCompanyRepresentatives && companyRepresentatives.length === 0"
                                class="pep-title">
                                Nenhum representante vinculado
                            </div>

                            <!-- Alerta de empresa não homologada (Modal) - MOVIMENTADO PARA BAIXO -->
                            <div *ngIf="selectedRepresentative === null && companyLookupStatus && companyLookupStatus !== 'homologado'"
                                class="mt-3 p-3 rounded d-flex align-items-center representative-error-alert">
                                <svg-icon
                                    src="assets/images/icon-warning.svg"></svg-icon>
                                <span>
                                    Esta empresa possui o status <strong>{{
                                        companyLookupStatus | uppercase
                                        }}</strong>.
                                    Somente empresas homologadas podem ser
                                    vinculadas como representantes.
                                </span>
                            </div>
                            <app-spacer [bottom]="24"></app-spacer>
                        </div>
                    </div>

                    <div class="row"
                        *ngIf="companyLookupName && !loadingCompanyRepresentatives && (companyLookupStatus === 'homologado' || selectedRepresentative !== null)">

                        <div class="col-12 col-lg-6">
                            <app-masked-input [group]="form"
                                controlName="term_validity" mask="00/00/0000"
                                label="Início do mandato"
                                placeholder="dd/mm/aaaa">
                            </app-masked-input>
                        </div>

                        <div class="col-12 col-lg-6">
                            <app-masked-input [group]="form"
                                [readOnly]="isIndefinite"
                                controlName="max_term_validity"
                                mask="00/00/0000" label="Validade do mandato"
                                placeholder="dd/mm/aaaa">
                            </app-masked-input>
                        </div>
                    </div>

                    <div class="row"
                        *ngIf="companyLookupName && !loadingCompanyRepresentatives && (companyLookupStatus === 'homologado' || selectedRepresentative !== null)">

                        <div class="col-12 col-lg-6">
                            <app-radio [multiple]="true"
                                formControlName="indefinite_term">
                                Validade indeterminada
                            </app-radio>
                            <app-spacer [bottom]="24"></app-spacer>
                        </div>
                    </div>
                </ng-container>

                <div class="row"
                    *ngIf="form.controls.representative_type.value === 'person'">
                    <div class="col-12 col-lg-6 cep-container">
                        <app-masked-input [group]="form" controlName="document"
                            label="CPF" placeholder="000.000.000-00"
                            mask="000.000.000-00"
                            (onChange)="searchRepresentative($event)">
                        </app-masked-input>
                        <svg-icon src="assets/images/icon-loading.svg"
                            *ngIf="loadingRepresentative"
                            class="app-button-icon"></svg-icon>
                    </div>
                </div>

                <app-spacer [bottom]="24"></app-spacer>

                <ng-container
                    *ngIf="form.controls.representative_type.value === 'person' && representativeFetched">
                    <div class="row">
                        <div class="col-12">
                            <app-input [group]="form" controlName="full_name"
                                label="Nome Completo" [maxLength]="60">
                            </app-input>
                            <app-spacer [bottom]="24"></app-spacer>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12 col-lg-6">
                            <app-masked-input [group]="form"
                                controlName="birth_date" mask="00/00/0000"
                                label="Data de nascimento"
                                placeholder="dd/mm/aaaa">
                            </app-masked-input>
                            <app-spacer [bottom]="24"></app-spacer>
                        </div>

                        <div class="col-12 col-lg-6">
                            <app-select
                                [items]="signupService.choices().marital_choices"
                                [group]="form" controlName="marital_status"
                                label="Estado civil" placeholder="Selecione">
                            </app-select>
                            <app-spacer [bottom]="24"></app-spacer>
                        </div>
                    </div>

                    <ng-container
                        *ngIf="form.controls.marital_status.value === '2' || this.form.controls['marital_status'].value === '3'">
                        <div class="row">
                            <div class="col-12 col-lg-4">
                                <app-masked-input [group]="form"
                                    controlName="spouse_document"
                                    label="CPF do cônjuge"
                                    placeholder="000.000.000-00"
                                    mask="000.000.000-00">
                                </app-masked-input>
                                <app-spacer [bottom]="24"></app-spacer>
                            </div>

                            <div class="col-12 col-lg-8">
                                <app-masked-input [group]="form"
                                    controlName="spouse_name"
                                    label="Nome do cônjuge" mask="W*"
                                    [usePatterns]="true">
                                </app-masked-input>
                                <app-spacer [bottom]="24"></app-spacer>
                            </div>

                            <div class="col-12 col-lg-12">
                                <app-select
                                    [items]="signupService.choices().marital_statutes"
                                    [group]="form" controlName="spouse_statute"
                                    label="Regime de casamento">
                                </app-select>
                                <app-spacer [bottom]="24"></app-spacer>
                            </div>
                        </div>
                    </ng-container>

                    <div class="row">
                        <div class="col-12 col-lg-6">
                            <app-input [group]="form" controlName="occupation"
                                [maxLength]="30" label="Ocupação Profissional">
                            </app-input>
                            <app-spacer [bottom]="24"></app-spacer>
                        </div>

                        <div class="col-12 col-lg-6">
                            <app-select
                                [items]="signupService.nationalityChocies"
                                [group]="form" controlName="nationality"
                                placeholder="Selecione" label="País de origem">
                            </app-select>
                            <app-spacer [bottom]="24"></app-spacer>
                        </div>

                        <div class="col-12 col-lg-6">
                            <app-select [items]="signupService.ufs_ids"
                                [group]="form" controlName="naturalness"
                                [readOnly]="isForeign" label="Naturalidade">
                            </app-select>
                            <app-spacer [bottom]="24"></app-spacer>
                        </div>

                        <div class="col-12 col-lg-6">
                            <app-select [items]="cities_options" [group]="form"
                                controlName="naturalness_city" label="Cidade"
                                [readOnly]="!form.controls.naturalness.value"
                                [placeholder]="form.controls.naturalness.value ? 'Selecione a cidade' : 'Selecione um Estado primeiro'">
                            </app-select>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12 col-lg-6">
                            <app-select
                                [items]="signupService.choices().document_types"
                                [group]="form" controlName="document_type"
                                label="Tipo de documento"
                                placeholder="Selecione">
                            </app-select>
                            <app-spacer [bottom]="24"></app-spacer>
                        </div>

                        <div class="col-12 col-lg-6">
                            <app-input [group]="form" controlName="rg"
                                [maxLength]="20" label="Número do Documento"
                                placeholder="0000000">
                            </app-input>
                            <app-spacer [bottom]="24"></app-spacer>
                        </div>

                        <div class="col-12 col-lg-4">
                            <app-select [items]="signupService.issuingAgencies"
                                [group]="form" controlName="issuing_agency"
                                label="Órgão expedidor">
                            </app-select>
                            <app-spacer [bottom]="24"></app-spacer>
                        </div>

                        <div class="col-12 col-lg-3">
                            <app-select [items]="signupService.ufs"
                                [group]="form" controlName="issuing_uf"
                                label="UF">
                            </app-select>
                            <app-spacer [bottom]="24"></app-spacer>
                        </div>

                        <div class="col-12 col-lg-5">
                            <app-masked-input [group]="form"
                                controlName="shipping_date" mask="00/00/0000"
                                label="Data expedição" placeholder="dd/mm/aaaa">
                            </app-masked-input>
                            <app-spacer [bottom]="24"></app-spacer>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12 col-lg-4">
                            <app-select [group]="form"
                                controlName="celphone_ddi" [items]="DDIOptions"
                                label="DDI">
                            </app-select>
                            <app-spacer [bottom]="24"></app-spacer>
                        </div>

                        <div class="col-12 col-lg-8">
                            <app-masked-input [group]="form"
                                controlName="celphone_number" label="Celular"
                                mask="(00) 00000-0000"
                                placeholder="(00) 0 0000-0000">
                            </app-masked-input>
                            <app-spacer [bottom]="24"></app-spacer>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            <app-input [group]="form" controlName="email"
                                label="E-mail">
                            </app-input>
                            <app-spacer [bottom]="24"></app-spacer>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12 col-lg-6">
                            <app-masked-input [group]="form"
                                controlName="term_validity" mask="00/00/0000"
                                label="Início do mandato"
                                placeholder="dd/mm/aaaa">
                            </app-masked-input>
                            <app-spacer [bottom]="24"></app-spacer>
                        </div>

                        <div class="col-12 col-lg-6">
                            <app-masked-input [group]="form"
                                [readOnly]="isIndefinite"
                                controlName="max_term_validity"
                                mask="00/00/0000" label="Validade do mandato"
                                placeholder="dd/mm/aaaa">
                            </app-masked-input>
                            <app-spacer [bottom]="24"></app-spacer>
                        </div>

                        <div class="col-12 col-lg-6">
                            <app-spacer [bottom]="36"></app-spacer>
                            <app-radio [multiple]="true"
                                formControlName="indefinite_term">
                                Validade indeterminada
                            </app-radio>
                            <app-spacer [bottom]="24"></app-spacer>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            <app-radio [multiple]="true" formControlName="pep">
                                <div class="flex-1 d-flex flex-column">
                                    <span class="pep-title">Considera-se
                                        PEP</span>
                                    <app-spacer [bottom]="8"></app-spacer>
                                    <span class="pep-description">Considera-se
                                        Pessoa Exposta Politicamente (PEP), nos
                                        termos da
                                        legislação em
                                        vigor, (i) agente público que desempenha
                                        ou
                                        tenha desempenhado, nos últimos cinco
                                        anos,
                                        no
                                        Brasil ou em
                                        países, territórios e dependências
                                        estrangeiras, cargos, empregos ou
                                        funções
                                        públicas
                                        relevantes; ou
                                        (ii) representante, familiar (parente na
                                        linha reta até primeiro grau, cônjuge,
                                        companheiro(a) ou
                                        enteado(a)).</span>
                                </div>
                            </app-radio>
                            <app-spacer [bottom]="48"></app-spacer>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12 col-lg-4 cep-container">
                            <app-masked-input [group]="form"
                                controlName="zipcode" label="CEP"
                                mask="00000-000" placeholder="00000-000"
                                (input)="handleSearchZipcode($event)">
                            </app-masked-input>
                            <svg-icon src="assets/images/icon-loading.svg"
                                *ngIf="searchingZipcode"
                                class="app-button-icon"></svg-icon>
                        </div>
                    </div>
                    <app-spacer [bottom]="24"></app-spacer>

                    <ng-container *ngIf="zipcodeFetched">
                        <div class="row">
                            <div class="col-12 col-lg-6">
                                <app-input [group]="form"
                                    controlName="public_place"
                                    label="Logradouro" [maxLength]="30"
                                    [readOnly]="addressObj.public_place !== ''">
                                </app-input>
                                <app-spacer [bottom]="24"></app-spacer>
                            </div>

                            <div class="col-12 col-lg-2">
                                <app-input [group]="form" controlName="number"
                                    type="number" label="Número">
                                </app-input>
                                <app-spacer [bottom]="24"></app-spacer>
                            </div>

                            <div class="col-12 col-lg-4">
                                <app-input [group]="form"
                                    controlName="complement" [maxLength]="20"
                                    label="Complemento">
                                </app-input>
                                <app-spacer [bottom]="24"></app-spacer>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-12 col-lg-6">
                                <app-input [group]="form" controlName="district"
                                    label="Bairro" [maxLength]="30"
                                    [readOnly]="addressObj.district !== ''">
                                </app-input>
                                <app-spacer [bottom]="24"></app-spacer>
                            </div>

                            <div class="col-12 col-lg-4">
                                <app-input [group]="form" controlName="city"
                                    [maxLength]="30" label="Cidade"
                                    [readOnly]="addressObj.city !== ''">
                                </app-input>
                                <app-spacer [bottom]="24"></app-spacer>
                            </div>

                            <div class="col-12 col-lg-2">
                                <app-select [items]="signupService.ufs"
                                    [group]="form" controlName="uf" label="UF"
                                    [readOnly]="addressObj.uf !== ''">
                                </app-select>
                                <app-spacer [bottom]="24"></app-spacer>
                            </div>

                            <div class="col-12 col-lg-4">
                                <app-select
                                    [items]="signupService.nationalityChocies"
                                    [group]="form" controlName="country"
                                    label="País"
                                    [readOnly]="addressObj.country !== ''">
                                </app-select>
                                <app-spacer [bottom]="24"></app-spacer>
                            </div>
                        </div>
                    </ng-container>
                </ng-container>

                <div class="row button-sticky">
                    <div class="col-12 col-lg-6">
                        <app-button (onClick)="handleCloseModal()"
                            class="add-button" [outline]="true">
                            Cancelar
                        </app-button>
                    </div>

                    <ng-container *ngIf="representativeFetched">
                        <div class="col-12 col-lg-6">
                            <div class="text-right">
                                <app-button (onClick)="triggerForm()"
                                    [loading]="sending"
                                    [disabled]="getDisabled()"
                                    class="add-button">
                                    Salvar representante
                                </app-button>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
        </app-side-modal>

        <ng-container *ngIf="representativeFetched || !showForm">
            <div class="row">
                <div class="col-12 col-lg-6 d-flex">
                    <app-button (onClick)="clearForm()" [disabled]="sending"
                        *ngIf="showForm" [outline]="true" class="mr-3">
                        Redefinir campos
                    </app-button>

                    <app-button (onClick)="triggerForm()" [loading]="sending"
                        [disabled]="getDisabled()" class="add-button"
                        [outline]="data.length > 0">
                        <svg-icon src="assets/images/icon-add.svg"
                            class="mr-2"></svg-icon>
                        {{data.length > 0 ? 'Adicionar outro representante'
                        :
                        'Adicionar representante'}}
                    </app-button>
                </div>
            </div>
        </ng-container>

        <app-warning-modal [active]="removeModal"
            (onClose)="handleRemoveCancel()">
            <h3>Você tem certeza?</h3>
            <app-spacer [bottom]="24"></app-spacer>
            <p>Você não poderá reverter essa ação!</p>
            <app-spacer [bottom]="56"></app-spacer>

            <app-button (onClick)="handleRemoveCancel()" [center]="true"
                class="add-button">
                Cancelar
            </app-button>

            <app-spacer [bottom]="8"></app-spacer>

            <app-button (onClick)="removeData(selectedIndex)" class="add-button"
                [center]="true" [outline]="true"
                [loading]="deletingRepresentative"
                [disabled]="deletingRepresentative">
                Sim, apague!
            </app-button>
        </app-warning-modal>

        <app-warning-modal [active]="warningRemoveModal"
            (onClose)="warningRemoveModal = false">
            <h3>Atenção</h3>
            <app-spacer [bottom]="24"></app-spacer>
            <p>
                Você não pode remover um representante que pertence a um grupo
                de
                poder de assinatura.
            </p>

            <p>
                Para remover esse representante, remova o grupo de poder de
                assinatura.
            </p>
            <app-spacer [bottom]="56"></app-spacer>

            <app-button (onClick)="warningRemoveModal = false" [center]="true"
                class="add-button">
                Ok
            </app-button>
        </app-warning-modal>
    </ng-container>
</form>